import axios from 'axios'

const client = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:5001/timelylimit/asia-northeast1'
      : 'https://asia-northeast1-timelylimit.cloudfunctions.net',
})

// https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
const numberWithCammas = number => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const parseBoolean = (value, defaultValue = undefined) => {
  const str = value.toLowerCase()
  switch (str) {
    case 'true':
      return true
    case 'false':
      return false
    default:
      return defaultValue
  }
}

// https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
const isMobile = (() => {
  const mobiles = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ]
  return mobiles.some(mobile => navigator.userAgent.match(mobile))
})()

export { client, numberWithCammas, isMobile, parseBoolean }
